import { useEffect, useState } from "react";
import { registerApiLoading, unregisterApiLoading } from "@/src/api/apiLoading";

export function GlobalApiLoader() {
  const [pending, setPending] = useState(0);

  useEffect(() => {
    registerApiLoading(setPending);
    return () => unregisterApiLoading();
  }, []);

  if (pending <= 0) return null;

  return (
    <div className="fixed inset-0 z-[90] bg-black/30 backdrop-blur-[2px] flex items-center justify-center">
      <div className="rounded-2xl border border-line bg-bg-card px-5 py-4 shadow-card flex items-center gap-3">
        <span className="h-4 w-4 rounded-full border-2 border-brand-gold/40 border-t-brand-gold animate-spin" />
        <span className="text-sm text-ink-secondary">Loading…</span>
      </div>
    </div>
  );
}

